import PropTypes from "prop-types"
import { LinkType } from "./link-type"

export const SubNavType = PropTypes.shape({
  category: PropTypes.shape({
    name: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
  }).isRequired,
  links: PropTypes.arrayOf(LinkType).isRequired,
})
